__webpack_require__.p = "/reports-legacy-reports-disabled/referrals-hub/";